import z from 'zod';
import { Localized } from '../../../../../../shared/type';

export interface SupporterItem {
  id?: number;
  user_id: number;
  nick_name: string;
  profile_image: string | null;
  money: Localized<number>;
  created_at: Date;
}

export const GetRecentSupportersParamsSchema = z.object({
  product_id: z.number(),
  created_at: z.string(),
  limit: z.number().optional(),
});

export const GetSupporterRankingsParamsSchema = z.object({
  product_id: z.number(),
  created_at: z.string(),
  amount: z.number().or(z.null()),
  limit: z.number().optional(),
});

export const FundingRecentSupportersFetchOptionValidator = GetRecentSupportersParamsSchema.transform(
  (data) => {
    return {
      product_id: Number(data.product_id),
      created_at: new Date(data.created_at),
      limit: data.limit || 15,
    };
  },
);

export const FundingSupporterRankingsFetchOptionValidator = GetSupporterRankingsParamsSchema.transform(
  (data) => {
    return {
      product_id: Number(data.product_id),
      created_at: new Date(data.created_at),
      amount: data.amount,
      limit: data.limit || 15,
    };
  },
);

export interface ResultQueriedByCursor<Data, Cursor> {
  data: Data;
  next_cursor: Cursor;
  has_more: boolean;
}

export type RecentSupportersParams = z.infer<typeof FundingRecentSupportersFetchOptionValidator>;
export type SupporterRankingsParams = z.infer<typeof FundingSupporterRankingsFetchOptionValidator>;

export type RecentSupportersResponse = ResultQueriedByCursor<SupporterItem[], Date>;
export type SupporterRankingsResponse = ResultQueriedByCursor<SupporterItem[], [Date, number | null]>;
